import { GHLLanguageKeys as e } from "./ghl-ui.es285.js";
const i = {
  name: e.italian,
  global: {
    undo: "Annulla",
    redo: "Rifare",
    confirm: "Confermare",
    clear: "Chiaro",
    more: "più",
    cancel: "Cancellare"
  },
  Popconfirm: {
    positiveText: "Confermare",
    negativeText: "Annulla"
  },
  Cascader: {
    placeholder: "Per favore seleziona.",
    loading: "Caricamento",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Chiaro",
    now: "Adesso",
    confirm: "Conferma",
    selectTime: "Seleziona l'orario",
    selectDate: "Seleziona data",
    datePlaceholder: "Seleziona la data",
    datetimePlaceholder: "Seleziona data e ora",
    monthPlaceholder: "Seleziona mese",
    yearPlaceholder: "Seleziona anno",
    quarterPlaceholder: "Seleziona il trimestre",
    startDatePlaceholder: "Data di inizio",
    endDatePlaceholder: "Data di fine",
    startDatetimePlaceholder: "Data e Ora di inizio",
    endDatetimePlaceholder: "Data e ora di fine",
    startMonthPlaceholder: "Mese di Inizio",
    endMonthPlaceholder: "Fine Mese",
    monthBeforeYear: !0,
    firstDayOfWeek: 0,
    today: "Oggi"
  },
  DataTable: {
    checkTableAll: "Selezionare tutto nella tabella.",
    uncheckTableAll: "Deseleziona tutto nella tabella.",
    confirm: "Confermare",
    clear: "Chiaro",
    apply: "Applica",
    filters: "Filtri",
    sort: "Ordinare"
  },
  LegacyTransfer: {
    sourceTitle: "Fonte",
    targetTitle: "Obiettivo"
  },
  Transfer: {
    selectAll: "Seleziona tutto",
    unselectAll: "Deseleziona tutto",
    clearAll: "Chiaro"
  },
  Empty: {
    description: "Nessun dato"
  },
  Select: {
    placeholder: "Per favore seleziona"
  },
  TimePicker: {
    placeholder: "Seleziona orario",
    positiveText: "OK",
    negativeText: "Annullare",
    now: "Ora"
  },
  Pagination: {
    goto: "Andare a",
    selectionSuffix: "pagina",
    next: "Prossimo",
    previous: "Precedente"
  },
  DynamicTags: {
    add: "Aggiungi"
  },
  Log: {
    loading: "Caricamento"
  },
  Input: {
    placeholder: "Per favore, inserisci"
  },
  InputNumber: {
    placeholder: "Inserisci per favore."
  },
  DynamicInput: {
    create: "Creare"
  },
  ThemeEditor: {
    title: "Editor di temi",
    clearAllVars: "Cancella tutte le variabili",
    clearSearch: "Cancella ricerca",
    filterCompName: "Nome del componente di filtro",
    filterVarName: "Nome variabile filtro",
    import: "importazione",
    export: "Esportazione",
    restore: "Ripristina impostazioni predefinite"
  },
  Image: {
    tipPrevious: "Immagine precedente (←)",
    tipNext: "Prossima immagine (→)",
    tipCounterclockwise: "Controverse",
    tipClockwise: "in senso orario",
    tipZoomOut: "Allontana l'immagine",
    tipZoomIn: "Ingrandisci",
    tipClose: "Chiudi (Esc)",
    tipOriginalSize: "Ingrandisci alla dimensione originale"
  },
  SortFilter: {
    heading: "Ordina e filtra",
    sortHeading: "Ordina per",
    newestFirst: "Più recenti per primi",
    oldestFirst: "Più vecchi per primi",
    ascending: "Crescente",
    descending: "Decrescente",
    aToZ: "A-Z",
    zToA: "Z-A",
    apply: "Applica",
    clear: "Cancella",
    cancel: "Annulla",
    filters: "Filtri"
  },
  IconPicker: {
    noMatchingFound: "Nessun risultato corrispondente trovato"
  },
  Spacing: {
    margin: "Margine",
    padding: "Imbottitura",
    reset: "Reimpostazione",
    errorMsg: "Il valore fornito non è valido."
  },
  BrandColorPicker: {
    brandColors: "Colori del marchio",
    noBrandColors: "Non hai ancora aggiunto colori del marchio.",
    getStarted: "Inizia",
    add: "Aggiungi",
    default: "Predefinito"
  }
};
export {
  i as it
};
